import React from 'react'
import styled from 'styled-components'

const StyledPageSection = styled.section`
  margin-bottom: 128px;
`

const StyledPageSectionTitle = styled.div`
  font-size: 24px;
  line-height: 32px;
  color: ${props => props.theme.dark2};
  margin-bottom: 32px;
`

const StyledPageSectionContent = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.dark4};
`

export const PageSection: React.FC<{
  title: React.ReactNode
}> = ({ title, children }) => {
  return (
    <StyledPageSection>
      <StyledPageSectionTitle>{title}</StyledPageSectionTitle>
      <StyledPageSectionContent>{children}</StyledPageSectionContent>
    </StyledPageSection>
  )
}
